const table = [
    {
        id: 1,
        name: 'Camille Jamerson',
        region: 'Senior Leadership',
        phone_number: '2489744215',
        personal_email: 'Cdj@cdjandassociates.com',
        school_email: 'N/A',
        for_mich_email: 'camille@4mich.org',
        staff_address: '22947 Valley View Dr. Southfield, MI 48033',
        job_title: 'Senior Leadership',
        start_date: '02-13-2024', 
        school: 'N/A'
    },
    {
        id: 2,
        name: 'Abbie Slate',
        region: 'Senior Leadership',
        phone_number: '3139496420',
        personal_email: 'abbie.raine2424@gmail.com',
        school_email: 'slate1ar@cmich.edu',
        for_mich_email: 'abbie@4mich.org',
        staff_address: '1484 Michigan Boulevard, Lincoln Park, MI 48146',
        job_title: 'Senior Leadership',
        start_date: '01-17-2024',
        school: 'N/A'
    },
    {
        id: 3,
        name: 'Quinton Berkompas',
        region: 'Senior Leadership',
        phone_number: '3603043632',
        personal_email: 'quintonberkompas@gmail.com',
        school_email: 'N/A',
        for_mich_email: 'quinton@4mich.org',
        staff_address: '3231 Chelsea Circle Ann Arbor, MI 48108',
        job_title: 'Senior Leadership',
        start_date: '01-08-2024', 
        school:'N/A'

    },
    {
        id: 4,
        name: 'LeLann Evans',
        region: 'Senior Leadership',
        phone_number: '6155542784',
        personal_email: 'lelannevans@gmail.com',
        school_email: 'N/A',
        for_mich_email: 'lelann@4mich.org',
        staff_address: 'Not Available',
        job_title: 'Senior Leadership',
        start_date: '02-12-2024', 
        school:'N/A'

    },
    {
        id: 5,
        name: 'Ben Hosler',
        region: 'Senior Leadership',
        phone_number: '2313295940',
        personal_email: 'Hosler.ben@icloud.com',
        school_email: 'bhosler@umich.edu',
        for_mich_email: 'ben@4mich.org',
        staff_address: '3157 Donald Ave Muskegon, MI 49442',
        job_title: 'Senior Leadership',
        start_date: '03-04-2024', 
        school:'N/A'
    },
    {
        id: 8,
        name: 'Aaeshah Siddiqui',
        region: 'Region 3 - Detroit',
        phone_number: '248-997-6297',
        personal_email: 'aaeshahsiddiqui@gmail.com',
        school_email: 'N/A',
        for_mich_email: 'aaeshah@4mich.org',
        staff_address: '74 Timberview Dr. Rochester Hills, MI 48307',
        job_title: 'Regional Organizing Director',
        start_date: '04-22-2024',
        school:'N/A'

    },
    {
        id: 7,
        name: 'Erica Cederberg',
        region: 'Region 2 - Northern',
        phone_number: '19894928452',
        personal_email: 'ekaznowski@gmail.com',
        for_mich_email: 'Erica@4mich.org',
        school_email:'N/A',
        staff_address: '2844 Wynes Street, Saginaw, MI 48602',
        job_title: 'Regional Organizing Director',
        start_date: '04-05-2024',
        school:'N/A'
    },
    {
        id: 6,
        name: 'Rylan Smith',
        region: 'Region 1 - Lansing',
        phone_number: '6618054511',
        personal_email: 'rylansmithjames@gmail.com',
        school_email: 'N/A',
        for_mich_email: 'rylan@4mich.org',
        staff_address: '216 W Saginaw St, East Lansing, MI 48823',
        job_title: 'Regional Organizing Director',
        start_date: '02-08-2024',
        school:'N/A'
    },
    {
        id: 9,
        name: 'Tyler Vanderhaag',
        region: 'Region 5 - Western',
        phone_number: '16162047372',
        personal_email: 'vanderhaagtyler@gmail.com',
        school_email: 'N/A',
        for_mich_email: 'tyler@4mich.org',
        staff_address: '6733 Knollcrest Street Northeast, Rockford, Michigan 49341',
        job_title: 'Regional Organizing Director',
        start_date: '03-04-2024',
        school:'N/A'
    },
   
    {
        id: 11,
        name: 'James Jandro',
        region: 'Region 1 - Lansing',
        phone_number: '19062807009',
        personal_email: 'jandrojames@gmail.com',
        school_email: 'N/A',
        for_mich_email: 'james@4mich.org',
        staff_address: '1218 Parkview Street, Lansing, MI 48912',
        job_title: 'Campus Organizer',
        start_date: '03-12-2024',
        school: 'Michigan State University, Lansing Community College'
    },
    {
        id: 13,
        name: 'Stanley Bullard',
        region: 'Region 1 - Lansing',
        phone_number: '15176678771',
        personal_email: 'stanleyaudible@gmail.com',
        school_email: 'N/A',
        for_mich_email: 'stanley@4mich.org',
        staff_address: '3478 Fieldberry Lane, Charlotte, MI',
        job_title: 'Campus Organizer',
        start_date: '06-20-2024', 
        school: 'Jackson College, Albion College'
    },
    {
        id: 10,
        name: 'Kaitlyn Robinson',
        region: 'Region 1 - Lansing',
        phone_number: '18109650760',
        personal_email: 'kaitlynarobinson01@gmail.com',
        school_email: 'N/A',
        for_mich_email: 'kaitlyn@4mich.org',
        staff_address: '1513 Crawford Street, Kalamazoo, MI',
        job_title: 'Campus Organizer',
        start_date: '06-20-2024',
        school:'University of Michigan - Flint, Kettering College, Mott Community College'
    },
    {
        id: 12,
        name: 'Matthew Anderson',
        region:'Region 1 - Lansing',
        phone_number:'18056579017',
        personal_email:'matthewbanderson64@gmail.com',
        school_email:'N/A',
        for_mich_email:'matthewA@4mich.org',
        staff_address:'731 Burcham Dr A103, East Lansing, MI',
        job_title:'Campus Organizer',
        start_date:'06-20-2024',
        school:'N/A'
    },
    {
        id:15,
        name:'Dominique Trondle',
        region:'Region 2 - Northern',
        phone_number:'9898024699',
        personal_email:	'dominiquetrondle@gmail.com',
        school_email:'N/A',
        for_mich_email:	'dtrondle@4mich.org',
        staff_address:'385 West Brown St., Beaverton, MI 48612',
        job_title:'Campus Organizer',
        start_date:'03-12-2024',
        school:'Central Michigan University, Alma College, Mid-Michigan College'
    },
    {
        id:14,
        name:'Allison Collins',
        region:'Region 2 - Northern',
        phone_number:'(989)293-5081',
        personal_email:'collinsallisonr@gmail.com',
        school_email:'N/A',
        for_mich_email:	'allison@4mich.org',
        staff_address: '1423 South Warren Avenue, Saginaw, MI',
        job_title: 'Campus Organizer',
        start_date:	'03-13-2024', 
        school:'Saginaw Valley State University, Delta College'

    },
    {
        id:17,
        name:'Tyler Simonson',
        region:	'Region 2 - Northern',
        phone_number: '16167805150',
        personal_email:	'simonson.tyler33@gmail.com',
        school_email: 'N/A',
        for_mich_email:	'Not Available',
        staff_address:'3636 Coleman Rd #922c, East Lansing, MI 48823',
        job_title:'Campus Organizer',
        start_date:'06-20-2024',
        school:'N/A'
    },
    {
        id:16,
        name:'Mariah Kiesling',
        region:	'Region 2 - Northern',
        phone_number:'15866049949',
        personal_email:'mariahk0705@gmail.com',
        school_email:'N/A',
        for_mich_email:'mariah@4mich.org',
        staff_address:	'3822 Pickford, Shelby Township, MI 48316',
        job_title:'Campus Organizer',
        start_date:	'06-20-2024', 
        school:'Ferris State University'

    },
    {
        id:18,
        name:'Adam Thompson',
        region:	'Region 3 - Detroit',
        phone_number:'18109414572',
        personal_email:	'adthomps@umich.edu',
        school_email:'adthomps@umich.edu',
        for_mich_email:	'adam@4mich.org',
        staff_address: '425 Cross Street, Ann Arbor, MI 48109',
        job_title:'Campus Organizer',
        start_date:'06-20-2024', 
        school:'Wayne State University, University of Detriot Mercy'
    },
    {
        id:21,
        name: 'Mridula Divakar',
        region: 'Region 3 - Detroit',
        phone_number: '12489895189',
        personal_email: 'mriduladivakar.4@gmail.com',
        school_email: 'N/A',
        for_mich_email: 'mridula@4mich.org',
        staff_address: '3467 John R Road, Troy, MI, USA',
        job_title: 'Campus Organizer',
        start_date: '06-20-2024',
        school:'N/A'
    },
    {
        id: 19,
        name: 'Andrew Milroy',
        region: 'Region 3 - Detroit',
        phone_number: '12695791823',
        personal_email: 'anmilroy@umich.edu',
        school_email: 'N/A',
        for_mich_email: 'andrew@4mich.org',
        staff_address: '52 Lynwood Dr, Battle Creek, MI, USA',
        job_title: 'Campus Organizer',
        start_date: '06-20-2024', 
        school:'Macomb Community College, Lawrence Technological University'
    },
    {
        id: 20,
        name: 'Emma Dedvukaj',
        region: 'Region 3 - Detroit',
        phone_number: '12489331653',
        personal_email: 'emmadedvukaj123@gmail.com',
        school_email: 'N/A',
        for_mich_email: 'emma@4mich.org',
        staff_address: '15 East Kirby Street, Detroit, MI 48202, USA',
        job_title: 'Campus Organizer',
        start_date: '06-20-2024', 
        school:'Oakland University, Oakland Community College'
    },
    {
        id: 22,
        name: 'Hannah Rogers',
        region: 'Region 4 - Ann Arbor',
        phone_number: '18012896848',
        personal_email: 'hannah@sixrogers.com',
        school_email: 'N/A',
        for_mich_email: 'Not Available',
        staff_address: '237 D Street, Salt Lake City, UT 84103, USA',
        job_title: 'Campus Organizer',
        start_date: '08-01-2024', 
        school:'University of Michigan - Ann Arbor, Washtenaw Community College'
    },
    {
        id: 23,
        name: 'Naomi Barbour',
        region: 'Region 4 - Ann Arbor',
        phone_number: '13132896101',
        personal_email: 'naomisbarbour@gmail.com',
        school_email: 'N/A',
        for_mich_email: 'naomi@4mich.org',
        staff_address: '900 Oakwood St, Ypsilanti, MI 48197, USA',
        job_title: 'Campus Organizer',
        start_date: '06-20-2024', 
        school: 'Eastern Michigan University, Monroe County Community College'
    },
    {
        id: 29,
        name: 'Seth Hyman',
        region: 'Region 5 - Western',
        phone_number: '5408786369',
        personal_email: 'Seth0129@gmail.com',
        school_email: 'N/A',
        for_mich_email: 'Seth@4mich.org',
        staff_address: '500 Bainbridge Street apt 2308, Richmond, Virginia 23224, USA',
        job_title: 'Campus Organizer',
        start_date: '03-12-2024', 
        school:'Western Michigan University, Kalamazoo College, Kalamazoo Valley Community College'
    },
    {
        id: 28,
        name: 'Patrick Jarvis',
        region: 'Region 5 - Western',
        phone_number: '2692520945',
        personal_email: 'ptrckjrvs@gmail.com',
        school_email: 'N/A',
        for_mich_email: 'Patrick@4mich.org',
        staff_address: '218 W University St, Wooster, OH, USA',
        job_title: 'Campus Organizer',
        start_date: '03-12-2024', 
        school:'Western Michigan University'
    },
    {
        id: 24,
        name: 'Alexander Chalom',
        region: 'Region 5 - Western',
        phone_number: '16168889015',
        personal_email: 'alexchalom23@gmail.com',
        school_email: 'N/A',
        for_mich_email: 'alex@4mich.org',
        staff_address: '4179 Imperial Drive Northwest, Grand Rapids, Michigan, USA',
        job_title: 'Campus Organizer',
        start_date: '06-20-2024', 
        schoo:'Grand Valley State University, Grand Rapids Community College, Aquinas College'
    },
    {
        id: 27,
        name: 'Olivia Tessin',
        region: 'Region 5 - Western',
        phone_number: '17343081524',
        personal_email: 'oliviagraec@gmail.com',
        school_email: 'N/A',
        for_mich_email: 'olivia@4mich.org',
        staff_address: '1513 Crawford St, Kalamazoo, MI, USA',
        job_title: 'Campus Organizer',
        start_date: '06-20-2024', 
        school:'Western Michigan University, Kalamazoo College, Kalamazoo Valley Community College'
    },
    {
        id: 30,
        name: 'Stanley Ibe',
        region: 'Region 3 - Detroit',
        phone_number: '12488269610',
        personal_email: 'soibe93@gmail.com',
        school_email: 'N/A',
        for_mich_email: 'StanleyI@4mich.org',
        staff_address: 'Oakland County, Michigan',
        job_title: 'Campus Organizer',
        start_date: '06-20-2024',
        school:'Oakland University, Oakland Community College'
    },
    {
        id: 25,
        name: 'Jaebie Camacho',
        region: 'Region 5 - Western',
        phone_number: '2693624456',
        personal_email: 'jaebiecamacho@gmail.com',
        school_email: 'N/A',
        for_mich_email: 'Not Available',
        staff_address: '1663 Ogden Ave, Bemtpm Harbor, MI 49022',
        job_title: 'Campus Organizer',
        start_date: '07-22-2024',
        school:'N/A'
    },
    {
        id: 26,
        name: 'Olivia Byers-Johnson',
        region: 'Region 5 - Western',
        phone_number: '16168486243',
        personal_email: 'byersjo1@msu.edu',
        school_email: 'byersjo1@msu.edu',
        for_mich_email: 'Not Available',
        staff_address: '996 N Baywood Dr, Holland, MI 49424',
        job_title: 'Campus Organizer',
        start_date: '07-22-2024',
        school:'Grand Valley State University, Grand Rapids Community College, Aquinas College'
    },
    {
        id: 39,
        name: 'Shriya Biddala',
        region: 'Region 4 - Ann Arbor',
        phone_number: '3034344366',
        personal_email: 'shriyarbiddala@gmail.com',
        school_email: 'sbiddala@umich.edu',
        for_mich_email: 'shriya@4mich.org',
        staff_address: 'N/A',
        job_title: 'Fellow',
        start_date: '03-04-2024',
        school:'University of Michigan - Ann Arbor'
    },
    {
        id: 37,
        name: 'Kevin Bautista-Mancilla',
        region: 'Region 3 - Detroit',
        phone_number: '2487362524',
        personal_email: 'kbautistamancilla@gmail.com',
        school_email: 'N/A',
        for_mich_email: 'N/A',
        staff_address: "901 Saint Louis Street Apt 23 Ferndale, MI 48220",
        job_title: 'Fellow',
        start_date: '03-04-2024',
        school:'N/A'
    },
    {
        id: 36,
        name: 'Madison Matalia',
        region: 'Region 2 - Northern',
        phone_number: '9062818546',
        personal_email: 'Not Available',
        school_email: 'mnmattil@mtu.edu',
        for_mich_email: 'N/A',
        staff_address: 'N/A',
        job_title: 'Fellow',
        start_date: '03-04-2024',
        school:'Michigan Technological University'
    },
    {
        id: 32,
        name: 'Sydney Woods',
        region: 'Region 1 - Lansing',
        phone_number: '3139328121',
        personal_email: 'sydney.lauren.woods.com',
        school_email: 'woodssy3@msu.edu',
        for_mich_email: 'N/A',
        job_title: 'Fellow',
        start_date: '03-04-2024',
        school:'Michigan State University'
    },
    {
        id: 31,
        name: 'Eva Oleita',
        region: 'Region 1 - Lansing',
        phone_number: '3132661523',
        personal_email: 'Oleitaeva@gmail.com',
        for_mich_email: 'N/A',
        staff_address: '1031 W Lake Lansing Rd, East Lansing MI, 48823',
        job_title: 'Fellow',
        start_date: '03-04-2024',
        school:'Michigan State University'
    },
    {
        id: 38,
        name: 'Thyaba Mymuna',
        region: 'Region 3 - Detroit',
        phone_number: '5868799745',
        personal_email: 'thyaba2005@gmail.com',
        school_email: 'Not Available',
        for_mich_email: 'N/A',
        staff_address: '29833 Wagner Dr. Warren MI 48093',
        job_title: 'Fellow',
        start_date: '03-04-2024',
        school:'Wayne State University'
    },
    {
        id: 36,
        name: 'Milo Demoines',
        region: 'Region 2 - Northern',
        phone_number: 'Not Available',
        personal_email: 'Not Available',
        school_email: 'Not Available',
        for_mich_email: 'Not Available',
        staff_address: 'N/A',
        job_title: 'Fellow',
        start_date: '03-11-2024',
        school:'N/A'
    },
    {
        id: 33,
        name: 'Ethan Colby',
        region: 'Region 2 - Northern',
        phone_number: 'Not Available',
        personal_email: 'Not Available',
        school_email: 'Not Available',
        for_mich_email: 'Not Available',
        staff_address: 'N/A',
        job_title: 'Fellow',
        start_date: '03-11-2024',
        school:'N/A'
    },
    {
        id: 34,
        name: 'Lily Martinez',
        region: 'Region 2 - Northern',
        phone_number: 'Not Available',
        personal_email: 'Not Available',
        school_email: 'Not Available',
        for_mich_email: 'Not Available',
        staff_address: 'N/A',
        job_title: 'Fellow',
        start_date: '03-19-2024',
        school:'N/A'
    },
    {
        id: 35,
        name: 'Olivia Byers-Johnson',
        region: 'Region 5 - Western',
        phone_number: 'Not Available',
        personal_email: 'Not Available',
        school_email: 'N/A',
        for_mich_email: 'oliviab@4mich.org',
        staff_address: 'Not Available',
        job_title: 'Campus Organizer',
        start_date: 'Not Available', 
        school:'Aquinas College'
    },
];

export function staffProfile(staffNameFirst, staffNameLast) {
    let staffProfileList = [];
    staffNameFirst = staffNameFirst.trim(); 
    staffNameLast = staffNameLast.trim();
    let staffName = staffNameFirst + ' ' + staffNameLast;
    for (let row of table) {
        let member = table.find(row => row.name === staffName);
        if (member) {
            let newDict = {};
            for (let key in member) {
                if (member.hasOwnProperty(key)) {
                    newDict[key] = member[key];
                }
            }
            staffProfileList.push(newDict);
        } else {
            let error = new Error(`404: ${staffName} is not an employee`);
            error.code = 404;
            throw error;
        }
    }
    let jsonStaffProfile = JSON.stringify(staffProfileList);
    return jsonStaffProfile;
}

export function regionProfile(region_in) {
    let regionList = table.filter(row => row.region === region_in);
    if (regionList.length === 0) {
        let error = new Error(`404: ${region_in} is not a region`);
        error.code = 404;
        throw error;
    }
    let jsonStaffProfile = JSON.stringify(regionList);
    return jsonStaffProfile;
}

export function jobProfile(job_in) {
    let jobList = table.filter(row => row.job_title === job_in);
    if (jobList.length === 0) {
        let error = new Error(`404: ${job_in} is not a job`);
        error.code = 404;
        throw error;
    }
    let jsonStaffProfile = JSON.stringify(jobList);
    return jsonStaffProfile;
}

export function schoolProfile(school_in) {
    let schoolList = table.filter(row => {
        if (!row.school) {
            return false; 
        }
        let schools = row.school.split(',').map(s => s.trim()); // Split and trim each school name
        return schools.includes(school_in);
    });
    if (schoolList.length === 0) {
        let error = new Error(`404: ${school_in} is not a recognized school`);
        error.code = 404;
        throw error;
    }
    let jsonSchoolProfile = JSON.stringify(schoolList);
    return jsonSchoolProfile;
}


//contains college name then add 4th querying 